import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set document title immediately
document.title = 'The Inherited House Survival Kit';
render(<App data-id="element-412" />, document.getElementById('root'));